import * as React from "react";
import { Track } from "../../../../components";
import { Segment } from "../Segment";
import { StaticProgressbar } from "../StaticProgressbar";
export class BetProgress extends React.Component {
    renderSegments() {
        return (React.createElement(React.Fragment, null,
            this.props.segments.periods.map((x, i) => {
                return (React.createElement(Segment, { key: `pb-p-p${i + 1}`, time: x.startTime, index: i + 1 }));
            }),
            React.createElement(Segment, { key: "pb-p-p4", time: this.props.segments.endTime, index: 4 })));
    }
    render() {
        return (React.createElement("div", { className: "rj-pulse-bet__progress-wrapper" },
            !this.props.isProgressFinished
                ? React.createElement(Track, { start: this.props.isGameInProgress, colors: this.props.colors, segments: this.props.segments, callbacks: this.props.callbacks })
                : React.createElement(StaticProgressbar, null),
            this.renderSegments()));
    }
}
//# sourceMappingURL=BetProgress.js.map